module.exports = __webpack_public_path__ + "img/swiperOne.9f269a55.png";